"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = SuccessIcon;

var _react = _interopRequireDefault(require("react"));

function SuccessIcon() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    fill: "#ffffff",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5.7550166,13.2349229 L1.2050166,8.68492285 C0.931661133,8.41156738 0.931661133,7.96835254 1.2050166,7.69496973 L2.19494238,6.7050166 C2.46829785,6.43163379 2.91154004,6.43163379 3.18489551,6.7050166 L6.24999316,9.77008691 L12.8150908,3.2050166 C13.0884463,2.93166113 13.5316885,2.93166113 13.8050439,3.2050166 L14.7949697,4.19496973 C15.0683252,4.4683252 15.0683252,4.91154004 14.7949697,5.18492285 L6.74496973,13.2349502 C6.47158691,13.5083057 6.02837207,13.5083057 5.7550166,13.2349229 Z"
  }));
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rainbow-components/components/Notification/icons/successIcon.js
// module id = f6dz
// module chunks = 0